/********************************************************************
 * Copyright (c) Certus Software, 2021.                             *
 *                                                                  *
 * This unpublished material is proprietary to Certus Software.     *
 * All rights reserved. The methods and techniques described        *
 * herein are considered confidential and/or trade secrets.         *
 * Reproduction or distribution, in whole or in part, is forbidden  *
 * except by express written permission of Certus Software.         *
 ********************************************************************/

import { NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';
import {ThemeModule} from './theme/theme.module';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { OnlyNumberDirective } from './directives/only-number.directive';
import {FirstKeyPipe} from './pipes/first-key.pipe';
import { FooterComponent } from './components/footer/footer.component';
import {AppbarComponent} from './components/appbar/appbar.component';
import { MainLayoutComponent } from './components/layout/main-layout/main-layout.component';
import { HttpErrorsComponent } from './components/http-errors/http-errors.component';
import { CookieDisabledComponent } from './components/cookie-disabled/cookie-disabled.component';
import { CookieDetailsComponent } from './components/cookie-details/cookie-details.component';
import {TranslateModule} from '@ngx-translate/core';
import { ProductDownloadSectionComponent } from './components/product-download-section/product-download-section.component';
import { GuideBannerComponent } from './components/guide-banner/guide-banner.component';
import {BreadcrumbModule} from 'xng-breadcrumb';
import { EmptyCompComponent } from './components/empty-comp/empty-comp.component';
import { GuideAsideComponent } from './components/layout/guide-aside/guide-aside.component';
import { GuidePaginationComponent } from './components/guide-pagination/guide-pagination.component';
import { XngCustomizationDirective } from './directives/xng-customization.directive';
import {CustomPaginatorDirective} from './directives/custom-paginator.directive';

const COMPONENTS = [
  OnlyNumberDirective,
  FirstKeyPipe,
  FooterComponent,
  MainLayoutComponent,
  AppbarComponent,
  ProductDownloadSectionComponent,
  GuideBannerComponent,
  GuideAsideComponent,
  GuidePaginationComponent
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ThemeModule,
    TranslateModule,
    BreadcrumbModule
  ],
  declarations: [
    COMPONENTS,
    HttpErrorsComponent,
    CookieDisabledComponent,
    CookieDetailsComponent,
    EmptyCompComponent,
    XngCustomizationDirective,
    CustomPaginatorDirective
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ThemeModule,
    COMPONENTS,
    TranslateModule,
    BreadcrumbModule,
    XngCustomizationDirective,
    CustomPaginatorDirective
  ]
})
export class SharedModule { }
